<div class="main-content">
    <div>
        <div class="card">
            <div class="card-header table-card-header d-flex flex-row">
                <div class="me-auto">
                    EIO & FXO
                </div>
                <div class="w-50 mx-auto"><pre class="mb-0">{{csvShortPath}}</pre></div>
                <div class="dropdown">
                    <div id="visuDownloadDropdownMenu"
                         class="logo-btn-small download dropdown-toggle" role="button"></div>
                    <div div class="dropdown-download dropdown-menu-right">
                        <button class="dropdown-item" (click)="onVisuExport()">
                            Download CSV
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-header table-card-header grid-control-bar d-flex flex-row">
                <div class="me-auto">
                    <div class="bnpp-btn-group btn-group btn-group-toggle"  name="radioBasic"
                         role="group">

                         <input type="radio" [(ngModel)]="isFxoSelected" (ngModelChange)="onTableSelection($event)" name="btnradio"
                         value='true' class="btn-check" id="eio" autocomplete="off">
                        <label class=" btn" [ngClass]="isFxoSelected ? 'active':''" for="eio">EIO</label>
                        <input type="radio" [(ngModel)]="isFxoSelected" (ngModelChange)="onTableSelection($event)" name="btnradio"
                         value='false' class="btn-check" id="fxo" autocomplete="off">
                        <label class=" btn" [ngClass]=" !isFxoSelected  ? 'active':''" for="fxo">FXO</label>

                        <!--<label ngbButtonLabel class="ms-1">
                            <input ngbButton type="radio" [value]="false"> EIO
                        </label>
                        <label ngbButtonLabel class="ms-2 me-1">
                            <input ngbButton type="radio" [value]="true"> FXO
                        </label>-->
                    </div>
                </div>

                <div class="form-inline my-2 my-lg-0">
                    <input class="form-control me-sm-2 form-control-sm grid-filter" type="search" placeholder="Search"
                           [(ngModel)]="searchText" aria-label="Search">
                </div>
            </div>
            <div class="ag-fresh angular_grid">
                <ag-grid-angular
                                 [quickFilterText]="searchText"
                                 [columnDefs]="columnDef"
                                 [rowData]="rowData"
                                 [gridOptions]="gridOptions"
                                 [domLayout]="domLayout"
                                 [overlayLoadingTemplate]="overlayLoadingTemplate"
                                 [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                 [suppressRowDeselection]="true"
                                 (gridReady)="onGridReady($event)">
                </ag-grid-angular>
            </div>
        </div>
        <br>
        <br>
        <div class="card" *ngIf="user?.isSuperAdmin">
            <div class="card-header table-card-header grid-control-bar d-flex flex-row justify-content-between">
                <div class="px-me-25">
                    BILLLING
                </div>

                <div class="dropdown" [class.d-none]="!showInvoiceAggregateFile">
                    <div id="visuDownloadDropdownMenu"
                         class="logo-btn-small download dropdown-toggle" role="button"></div>
                    <div div class="dropdown-download dropdown-menu-right">
                        <button class="dropdown-item" (click)="onInvoicesDownload()">
                            Download CSV
                        </button>
                    </div>
                </div>

                <div class="form-inline my-2 my-lg-0">
                    <input class="form-control search me-sm-2 form-control-sm grid-filter" type="date" 
                            [(ngModel)]="inputDate">
                    <button type="button" class="btn btn-sm btn-basic bnpp-btn px-w-75" (click)="onInvoiceRun()" 
                            [disabled]="!inputDate || invoiceAreBeingUpdated">RUN</button>       
                </div>
            </div>
        </div>
    </div>
</div>
